import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, MatCheckboxModule]
})
export class CheckboxComponent implements OnInit {
  @Input() form: FormGroup | undefined;
  @Input() formGroupName: string | undefined;
  @Input() label: string = '';

  constructor() {}

  ngOnInit() {

  }

}
